module.exports = __webpack_public_path__ + "img/webhooks.f57a0214.png";